'use client';

import { Controller, type FieldValues } from 'react-hook-form';
import { Input } from '@kidslabs/mario-nextjs-react-ui-core';
import { useCallback } from 'react';
import type { TextFieldProps } from './text-field.types';

import styles from './text-field.module.css';

export const TextField = <T extends FieldValues>({
    name,
    control,
    errorMessage,
    disabled,
    testID = 'text-field',
    placeHolder,
    onClearValue,
}: TextFieldProps<T>) => {
    const handleTextChange = useCallback(
        (text: string, onChange: (text: string) => void) => {
            if (!text) {
                onClearValue?.();
            }
            onChange(text);
        },
        [onClearValue]
    );

    return (
        <div className={styles.container}>
            <Controller
                control={control}
                name={name}
                render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
                    <Input
                        className={styles.input}
                        placeholder={placeHolder}
                        variant="filled"
                        onBlur={onBlur}
                        onChange={event => handleTextChange(event?.target?.value, onChange)}
                        value={value}
                        error={errorMessage ?? error?.message}
                        disabled={disabled}
                        testID={testID}
                    />
                )}
            />
        </div>
    );
};
